import { useState } from "react";
import { ShieldAlert, ShieldCheck, Mail, Loader } from "lucide-react";
import toast from "react-hot-toast";
import api from "../../api/axios";
import { useLanguage } from "../../context/LanguageContext";

export default function Banner({ role, user }) {
  const { t } = useLanguage();
  const [loading, setLoading] = useState(false);

  const handleVerifyEmail = async () => {
    setLoading(true);
    try {
      await api.post("/auth/send-verification", { origin: window.location.origin });
      toast.success(t('banner_sent'));
    } catch (err) {
      toast.error(err.response?.data?.error === "already_verified"
        ? t('banner_already')
        : t('banner_fail'));
    } finally {
      setLoading(false);
    }
  };

  // 0. EMAIL VERIFICATION (Universal Priority)
  if (user && !user.isEmailVerified) {
    return (
      <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-xl p-4 shadow-sm text-sm flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mt-4">
        <div className="flex items-start gap-3">
          <Mail className="w-5 h-5 text-blue-600 dark:text-blue-400 shrink-0 mt-0.5" />
          <div>
            <p className="text-blue-800 dark:text-blue-200 font-semibold mb-1">{t('banner_verify_email')}</p>
            <p className="text-blue-800/80 dark:text-blue-200/80">
              {t('banner_verify_desc')}
            </p>
          </div>
        </div>
        <button
          onClick={handleVerifyEmail}
          disabled={loading}
          className="whitespace-nowrap px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors flex items-center gap-2 disabled:opacity-50"
        >
          {loading ? <Loader className="w-4 h-4 animate-spin" /> : <ShieldCheck className="w-4 h-4" />}
          {loading ? t('banner_sending') : t('banner_verify_btn')}
        </button>
      </div>
    );
  }

  // 1. PROVIDER Logic (Profile Verification)
  // HIDDEN FOR MVP1 PER USER REQUEST
  /*
  if (role === "PROVIDER" || role === "Provider") {
    const status = user?.provider?.verificationStatus;

    // A. Fully Verified -> Show Nothing
    if (status === "VERIFIED") return null;

    // B. Verification Pending (Uploaded but not approved)
    if (status === "PENDING") {
      return (
        <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-xl p-4 shadow-sm text-sm flex items-start gap-3 mt-4">
          <ShieldCheck className="w-5 h-5 text-blue-600 dark:text-blue-400 shrink-0 mt-0.5" />
          <div>
            <p className="text-blue-800 dark:text-blue-200 font-semibold mb-1">Verification Pending</p>
            <p className="text-blue-800/80 dark:text-blue-200/80">
              Your profile is being reviewed by our sanctuary gatekeepers. We'll notify you once you're cleared for discovery.
            </p>
          </div>
        </div>
      );
    }

    // C. Action Required (Hasn't uploaded certificate or rejected)
    return (
      <div className="bg-orange-50 dark:bg-orange-900/20 border border-orange-200 dark:border-orange-800 rounded-xl p-4 shadow-sm text-sm flex items-start gap-3 mt-4">
        <ShieldAlert className="w-5 h-5 text-orange-600 dark:text-orange-400 shrink-0 mt-0.5" />
        <div>
          <p className="text-orange-800 dark:text-orange-200 font-semibold mb-1">Action Required</p>
          <p className="text-orange-800/80 dark:text-orange-200/80">
            Don’t forget to complete your profile verification. Upload your certificates to build trust with others.
          </p>
        </div>
      </div>
    );
  }
  */

  return null;
}
